/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import MaterialTable from 'material-table';
import { IconButton, Tooltip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import { toast } from 'react-toastify';

import useStyles from './style';
import { findPermission } from '../../../../services/auth';
import {
  consultarPorAncoraId,
  consultarPerfisErpAtivos,
  apagar,
} from '../../../../services/ancorasImportacoesTitulosService';

function formatDateTime(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}`;
}

function formatTime(value) {
  if (!value) return '';
  const m = String(value).match(/(\d{2}):(\d{2})/);
  return m ? `${m[1]}:${m[2]}` : '';
}

function GridAncorasImportacoesTitulos({ ancoraId, visualize }) {
  const classes = useStyles();
  const [vinculos, setVinculos] = useState([]);
  const [perfisMap, setPerfisMap] = useState({});
  const [loading, setLoading] = useState(false);

  const carregar = useCallback(async () => {
    if (!ancoraId) return;
    setLoading(true);
    try {
      const [lista, perfis] = await Promise.all([
        consultarPorAncoraId(ancoraId),
        consultarPerfisErpAtivos(),
      ]);
      const map = {};
      (perfis || []).forEach((p) => {
        map[p.importacaoTituloApiErpId] = `${p.erp || ''} v${p.versao || ''}`;
      });
      setPerfisMap(map);
      setVinculos(Array.isArray(lista) ? lista.filter((x) => !x.message) : []);
    } catch (e) {
      // erro global ja tratado
    }
    setLoading(false);
  }, [ancoraId]);

  useEffect(() => {
    carregar();
  }, [carregar]);

  const handleRemover = async (row) => {
    if (!row || !row.ancoraImportacaoTituloApiErpId) return;
    if (!window.confirm('Tem certeza que deseja remover esta integracao?')) return;
    try {
      await apagar(row.ancoraImportacaoTituloApiErpId);
      toast.success('Integracao removida com sucesso!');
      carregar();
    } catch (e) {
      // erro global ja tratado
    }
  };

  return (
    <>
      <div className={classes.actions}>
        {!visualize && !!findPermission(58872, 'Cadastrar') && ancoraId && (
          <Link
            className={classes.button}
            to={`/app/ancoras-integracoes-titulos/${ancoraId}/cadastrar`}
          >
            <span>Novo Item</span>
          </Link>
        )}
      </div>

      <MaterialTable
        className={classes.table}
        isLoading={loading}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          paging: false,
        }}
        columns={[
          {
            title: 'Apelido',
            field: 'apelido',
            cellStyle: { fontSize: '13px', padding: '8px 16px' },
          },
          {
            title: 'Perfil ERP',
            field: 'importacaoTituloApiErpId',
            cellStyle: { fontSize: '13px', padding: '8px 16px' },
            render: (row) => perfisMap[row.importacaoTituloApiErpId] || row.importacaoTituloApiErpId,
          },
          {
            title: 'Tenant',
            field: 'tenantSlug',
            cellStyle: { fontSize: '13px', padding: '8px 16px' },
            render: (row) => row.tenantSlug || '-',
          },
          {
            title: 'Lojas',
            field: 'lojasKeys',
            cellStyle: { fontSize: '13px', padding: '8px 16px', width: '110px' },
            render: (row) => {
              const csv = row.lojasKeys;
              if (!csv || String(csv).trim() === '') return 'Todas';
              const keys = String(csv)
                .split(',')
                .map((v) => v.trim())
                .filter((v) => v.length > 0);
              if (keys.length === 0) return 'Todas';
              return (
                <Tooltip title={keys.join(', ')}>
                  <span>{`${keys.length} loja${keys.length > 1 ? 's' : ''}`}</span>
                </Tooltip>
              );
            },
          },
          {
            title: 'Horario Full',
            field: 'horarioGeracaoFull',
            cellStyle: { fontSize: '13px', padding: '8px 16px', width: '110px' },
            render: (row) => formatTime(row.horarioGeracaoFull),
          },
          {
            title: 'Horario Compl.',
            field: 'horarioGeracaoComplementar',
            cellStyle: { fontSize: '13px', padding: '8px 16px', width: '110px' },
            render: (row) => formatTime(row.horarioGeracaoComplementar),
          },
          {
            title: 'Ultima Geracao Full',
            field: 'dataUltimaGeracaoFull',
            cellStyle: { fontSize: '13px', padding: '8px 16px' },
            render: (row) => formatDateTime(row.dataUltimaGeracaoFull),
          },
          {
            title: 'Status',
            field: 'status',
            cellStyle: { fontSize: '13px', padding: '8px 16px', width: '90px' },
          },
          {
            title: 'Acoes',
            field: 'actions',
            headerStyle: { textAlign: 'center' },
            cellStyle: { fontSize: '13px', textAlign: 'center', padding: '8px 16px', width: '150px' },
            sorting: false,
            render: (row) => (
              <>
                {!!findPermission(58872, 'Consultar') && (
                  <Link
                    to={`/app/ancoras-integracoes-titulos/visualizar/${row.ancoraImportacaoTituloApiErpId}`}
                  >
                    <IconButton size="small">
                      <VisibilityIcon style={{ fontSize: 26, color: '#4AAF05' }} />
                    </IconButton>
                  </Link>
                )}
                {!visualize && !!findPermission(58872, 'Alterar') && (
                  <Link
                    to={`/app/ancoras-integracoes-titulos/editar/${row.ancoraImportacaoTituloApiErpId}`}
                  >
                    <IconButton size="small">
                      <EditIcon style={{ fontSize: 26, color: '#FB8832' }} />
                    </IconButton>
                  </Link>
                )}
                {!visualize && !!findPermission(58872, 'Apagar') && (
                  <IconButton size="small" onClick={() => handleRemover(row)}>
                    <DeleteIcon style={{ fontSize: 26, color: '#FF5756' }} />
                  </IconButton>
                )}
              </>
            ),
          },
        ]}
        data={vinculos}
        localization={{
          body: { emptyDataSourceMessage: 'Nenhuma integracao cadastrada' },
        }}
      />
    </>
  );
}

export default GridAncorasImportacoesTitulos;
